const isPageReloaded = () => {
  try {
    const latestNav = window.performance.getEntriesByType("navigation")[0];

    return latestNav.entryType === "reload";
  } catch {
    return false;
  }
};

export default isPageReloaded;
